// TimeConfirmModal.tsx
import classNames from 'classnames';
import { ReactElement, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { timeConfirmStore } from './TimeConfirmStore';
import { BUTTON_TITLE } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { modalStore } from '~/mobx/modalStore';
import './style.scss';

export const TimeConfirmModal = observer((): ReactElement | null => {
  const modalData = modalStore.timeConfirmModal;
  if (!modalData) {
    return null;
  }

  useEffect(() => {
    timeConfirmStore.init(modalData.time ?? null);
    return () => {
      timeConfirmStore.reset();
    };
  }, [modalData]);

  const { loading, condition, confirmButtonTitle, handleConfirm, handleCancel } = timeConfirmStore;

  return (
    <CustomModalComponent
      isOpen={Boolean(modalData)}
      className={classNames('time-confirm-modal', modalData.className)}
      overlayClassName="time-confirm-modal__overlay"
      onRequestClose={handleCancel}
      withCloseIcon
    >
      <ModalBackground className="d-flex flex-column align-items-center p-2">
        <Text type={TEXT.BLOCK_HEADER} text={modalData.title} className="time-confirm-modal__title mt-1" />
        <Text type={TEXT.CUSTOM} text={modalData.message} className="time-confirm-modal__text mt-3" />
        <div className="d-flex flex-row justify-content-center full-width mt-4 gap-10">
          {modalData.onConfirm && (
            <Button
              title={confirmButtonTitle}
              loading={loading}
              onClick={handleConfirm}
              disabled={condition || loading}
              appearance={condition || loading ? 'destructive-secondary' : 'destructive-primary'}
              stretched
            />
          )}
          {modalData.onCancel && (
            <Button title={localeStore.t(modalData.onCancelTxt ?? BUTTON_TITLE.NO)} onClick={handleCancel} appearance="tertiary" stretched />
          )}
        </div>
      </ModalBackground>
    </CustomModalComponent>
  );
});
